import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Title } from 'components/layout'
import { Textarea } from 'components/fields'
import { form } from 'helpers/decorators'

@form({
  form: 'assessorReportReject'
})
class AssessorReportRejected extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    modalId: PropTypes.string.isRequired
  }

  handleSubmit = data => {
    this.props.modal(null, null)
    this.props.onSubmit(data)
  }

  render() {
    const { handleSubmit } = this.props

    return (
      <Modal
        id={this.props.modalId}
        action="Send"
        intlKeyAction="button.send"
        onSubmit={handleSubmit(this.handleSubmit)}
      >
        <form
          name="assessorReportReject"
          onSubmit={handleSubmit(this.handleSubmit)}
        >
          <Title h3 intlKey="moduleTitle.assessor_report_reject">
            Assessor Report Reject
          </Title>

          <div className="row">
            <div className="col-xs-12">
              <Textarea
                label="Note"
                name="note"
                intlKey="label.note"
                placeholder="Please leave a note"
                intlKeyPlaceholder="label.please_leave_a_note"
              />
            </div>
          </div>
        </form>
      </Modal>
    )
  }
}

export default AssessorReportRejected
